import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfigComponent } from './config.component';
import { ConfigDefaultComponent } from './config-default.component';
import { AuthGuard } from '../core/services';

const routes: Routes = [
  {
    path: 'config',
    component: ConfigComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: ConfigDefaultComponent, canActivate: [AuthGuard] },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigRoutingModule { }
